import { render, staticRenderFns } from "./ResetPwdWindow.vue?vue&type=template&id=2760c392&scoped=true&"
import script from "./ResetPwdWindow.vue?vue&type=script&lang=js&"
export * from "./ResetPwdWindow.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwdWindow.vue?vue&type=style&index=0&id=2760c392&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2760c392",
  null
  
)

export default component.exports